import React from "react";
import * as ImIcons from "react-icons/im";
import * as HiIcons from "react-icons/hi";
import * as FaIcons from "react-icons/fa";

export default function Contact() {
  return (
    <section className="section-portfolio">
      <div className="container">
        <div className="content">
          <h1 className="title">Portfolio.</h1>
          <div className="card-list">
            <div className="card-item text-center">
              <div className="card-image text-5xl">
                <HiIcons.HiOutlineMail className="mx-auto" />
                <p className="text-base py-1">Email</p>
              </div>
              <div className="card-text">
                <p className="card-description">muhammadfathur88@gmail.com</p>
                <a
                  href="mailto:muhammadfathur88@gmail.com" target="_blank"
                  className="flex items-center gap-2 justify-center mt-2"
                >
                  Email me <ImIcons.ImArrowRight2 />
                </a>
              </div>
            </div>
            <div className="card-item text-center">
              <div className="card-image text-5xl">
                <ImIcons.ImWhatsapp className="mx-auto" />
                <p className="text-base py-1">WhatsApp</p>
              </div>
              <div className="card-text">
                <p className="card-description">+62 851-5505-6447</p>
                <a
                  href="https://wa.me/+6285155056447" target="_blank"
                  className="flex items-center gap-2 justify-center mt-2"
                >
                  Chat me <ImIcons.ImArrowRight2 />
                </a>
              </div>
            </div>
            <div className="card-item text-center">
              <div className="card-image text-5xl">
                <FaIcons.FaTelegramPlane className="mx-auto" />
                <p className="text-base py-1">Telegram</p>
              </div>
              <div className="card-text">
                <p className="card-description">+62 851-5505-6447</p>
                <a
                  href="https://t.me/muhfathurrah16" target="_blank"
                  className="flex items-center gap-2 justify-center mt-2"
                >
                  Chat me <ImIcons.ImArrowRight2 />
                </a>
              </div>
            </div>
            <div className="card-item text-center">
              <div className="card-image text-5xl">
                <ImIcons.ImLinkedin2 className="mx-auto" />
                <p className="text-base py-1">LinkedIn</p>
              </div>
              <div className="card-text">
                <p className="card-description">Muhamad Fathur Rahman</p>
                <a
                  href="https://linkedin.com/in/muhfathurrah16/" target="_blank"
                  className="flex items-center gap-2 justify-center mt-2"
                >
                  Connect with me <ImIcons.ImArrowRight2 />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
